import { BaseEntity } from './base-entity';

export enum MediaType {
  AVATAR = 'avatar',
  BADGE = 'badge-icon',
  BOOK = 'book',
  BOOK_COVER = 'book-cover',
  BOOK_COVER_TALL = 'book-cover-tall',
  BOOK_COVER_SHORT = 'book-cover-short',
  BOOK_FEATURED_IMAGE = 'book-featured_image',
  BOOK_FEATURED_MOBILE_IMAGE = 'book-featured_mobile_image',
  BOOK_LEARNING_MATERIAL = 'book-info',
  BOOK_JSON_DATA = 'book-json-data',
  TERM = 'term',
  SUBSCRIPTION_PACKAGE = 'subscription_package',
  BOOK_PREVIEW = 'book-preview',
  BOOK_PREVIEW_VIDEO_IMAGE = 'book-preview_image',
  BOOK_SOUND_TRACK = 'book-sound_track',
  LEVEL_QUESTION_IMAGE = 'question-image',
  LEVEL_QUESTION_AUDIO = 'question-audio',
  PARTNER_LOGO = 'partner-logo'
}

export enum MimeType {
  JPG = '.jpg',
  JPEG = '.jpeg',
  PNG = '.png',
  BKR = '.bkr',
  EPUB = '.epub',
  PDF = '.pdf',
  MP4 = '.mp4'
}

export interface FileMedia {
  original: string;
  optimal: string;
  original_xl: string;
  original_s: string;
  landscape_m: string;
  cut_s: string;
}

export class Media extends BaseEntity {
}

export const DefaultImageTypes = [MimeType.JPG, MimeType.JPEG, MimeType.PNG];

export const MimeTypes = [
  { mediaType: MediaType.AVATAR, mime: DefaultImageTypes },
  { mediaType: MediaType.BADGE, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK, mime: [MimeType.BKR] },
  { mediaType: MediaType.BOOK_COVER, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_COVER_TALL, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_COVER_SHORT, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_FEATURED_IMAGE, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_FEATURED_MOBILE_IMAGE, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_LEARNING_MATERIAL, mime: [MimeType.PDF] },
  { mediaType: MediaType.TERM, mime: DefaultImageTypes },
  { mediaType: MediaType.SUBSCRIPTION_PACKAGE, mime: DefaultImageTypes },
  { mediaType: MediaType.BOOK_PREVIEW, mime: [MimeType.MP4] },
  { mediaType: MediaType.BOOK_PREVIEW_VIDEO_IMAGE, mime: DefaultImageTypes }
];
